module.exports = __webpack_public_path__ + "static/media/data.e10187f7.jpg";